import { render, staticRenderFns } from "./PromotionsModals.vue?vue&type=template&id=d40af4c6&"
import script from "./PromotionsModals.vue?vue&type=script&lang=js&"
export * from "./PromotionsModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40af4c6')) {
      api.createRecord('d40af4c6', component.options)
    } else {
      api.reload('d40af4c6', component.options)
    }
    module.hot.accept("./PromotionsModals.vue?vue&type=template&id=d40af4c6&", function () {
      api.rerender('d40af4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/PromotionsModals.vue"
export default component.exports